import { CSSProperties, FC, ReactNode } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import OverflowFadeScrollArea from '../../OverflowFadeScrollArea';

interface DashedPaneProps {
    children: ReactNode;
    contentStyle?: CSSProperties;
    height?: CSSProperties['height'];
    marginTop?: CSSProperties['marginTop'];
    padding?: CSSProperties['padding'];
    style?: CSSProperties;
}

const DashedPane: FC<DashedPaneProps> = ({
    children,
    contentStyle,
    height = '20rem',
    marginTop = '0.75rem',
    padding = '0 0.75rem',
    style,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <OverflowFadeScrollArea
            containerStyle={{
                marginTop,
                height,
                border: `1px dashed ${token.colorBorder}`,
                borderRadius: token.borderRadius,
                ...style,
            }}
            contentStyle={contentStyle}
            style={{ padding }}
            surface='container'
        >
            {children}
        </OverflowFadeScrollArea>
    );
};

export default DashedPane;
